import React, { useState } from "react";
import { Box, Button, CircularProgress, Grid2, Typography } from "@mui/material";
import axios from "axios";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { viewPDF } from "../../../utils/viewPDF";
import { uploadFile } from "../../../utils/uploadToAzure";

const EditStep6 = ({ tender, setTender, user, setStep, fileNames, setFileNames }) => {
  const [errors, setErrors] = useState({});
  const [uploadLoading, setUploadLoading] = useState({
    tnc: false,
    serviceAgreement: false,
    protection: false,
  });
  const orgId = JSON.parse(localStorage.getItem("org"));

  const handleChange = (e) => {
    setTender({ ...tender, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const setFieldLoading = (field, isLoading) => {
    setUploadLoading((prev) => ({
      ...prev,
      [field]: isLoading,
    }));
  };

  const handleFileUpload = async (e) => {
    const { name, files } = e.target;
    setFieldLoading(name, true);
    if (files && files.length > 0) {
      const file = files[0]; // Get the first file

      // Update the file names state
      setFileNames((prev) => ({
        ...prev,
        [name]: file.name, // Set the filename in state
      }));

      const formData = new FormData();
      formData.append("file", file);

      try {
        const res = await uploadFile(file, orgId, tender.tenderId, user)
        // Set the received file path in tender state
        setTender({ ...tender, [e.target.name]: res });
        setErrors({ ...errors, [e.target.name]: "" });
      } catch (error) {
        setErrors({ ...errors, [e.target.name]: "Cannot upload file. Make sure file size is less than 1MB" });
      } finally {
        setFieldLoading(name, false);
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const data = tender || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.buyerTNC)) {
      newErrors.buyerTNC = "Buyer added text based clauses is required";
    } else if(data.buyerTNC.length > 255){
      newErrors.longDesc = "Buyer added text based clauses should be upto 255 characters";
    }
    if (isEmpty(data.tnc) || errors.tnc) newErrors.tnc = "Terms and Conditions is required";
    if (isEmpty(data.serviceAgreement) || errors.serviceAgreement)
      newErrors.serviceAgreement = "Service Level Agreement is required";
    if (isEmpty(data.protection) || errors.protection)
      newErrors.protection = "Safety and Environment Protection is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    setStep((prev) => prev + 1);
  };

  const handleBack = () => {
    if (tender.isSingleBid) {
      setStep((prev) => prev - 2);
    } else {
      setStep((prev) => prev - 1);
    }
  };
  return (
    <div>
      <h2>Edit Tender</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{width: '100%'}}></span>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">
          Buyer Added Bid Specific Terms and Conditions
        </Typography>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 12 }}>
            <label htmlFor="buyerTNC">Buyer Added Text Based Clauses</label>
            <textarea
              name="buyerTNC"
              id="buyerTNC"
              className={`${errors.buyerTNC && "input-error"}`}
              rows={8}
              onChange={handleChange}
              value={tender && tender.buyerTNC}
            ></textarea>
            {errors.buyerTNC && <p className="error">{errors.buyerTNC}</p>}
          </Grid2>
        </Grid2>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">
          General Terms and Conditions
        </Typography>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="tnc">
              Terms and Conditions
              <div className="input-file">
                <input
                  type="file"
                  id="tnc"
                  name="tnc"
                  onChange={handleFileUpload}
                />
                <span
                  style={{
                    width: "80%",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {fileNames.tnc || "No file chosen"}
                </span>
                <AttachFileIcon
                  fontSize="small"
                  sx={{
                    color: "#555",
                    transform: "rotate(90deg)",
                    "&:hover": { color: "#1A71F6BF" },
                  }}
                />
              </div>
            </label>
            {uploadLoading.tnc && <span style={{fontSize: '12px'}}>Uploading File... <CircularProgress size="30px" /></span>}
            {errors.tnc && <p className="error">{errors.tnc}</p>}
            {tender && tender.tnc && (
              <Button
                sx={{
                  margin: "-6% 0 0 0 !important",
                  width: "max-content !important",
                  fontSize: "12px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.tnc, user)}
              >
                {tender.tncFilename || fileNames.tnc}
              </Button>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="serviceAgreement">
              Service Level Agreement
              <div className="input-file">
                <input
                  type="file"
                  id="serviceAgreement"
                  name="serviceAgreement"
                  onChange={handleFileUpload}
                />
                <span
                  style={{
                    width: "80%",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {fileNames.serviceAgreement || "No file chosen"}
                </span>
                <AttachFileIcon
                  fontSize="small"
                  sx={{
                    color: "#555",
                    transform: "rotate(90deg)",
                    "&:hover": { color: "#1A71F6BF" },
                  }}
                />
              </div>
            </label>
            {uploadLoading.serviceAgreement && <span style={{fontSize: '12px'}}>Uploading File... <CircularProgress size="30px" /></span>}
            {errors.serviceAgreement && (
              <p className="error">{errors.serviceAgreement}</p>
            )}
            {tender && tender.serviceAgreement && (
              <Button
                sx={{
                  margin: "-6% 0 0 0 !important",
                  width: "max-content !important",
                  fontSize: "12px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.serviceAgreement, user)}
              >
                {tender.serviceAgreementFilename || fileNames.serviceAgreement}
              </Button>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="protection">
              Safety and Environment Protection
              <div className="input-file">
                <input
                  type="file"
                  id="protection"
                  name="protection"
                  onChange={handleFileUpload}
                />
                <span
                  style={{
                    width: "80%",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {fileNames.protection || "No file chosen"}
                </span>
                <AttachFileIcon
                  fontSize="small"
                  sx={{
                    color: "#555",
                    transform: "rotate(90deg)",
                    "&:hover": { color: "#1A71F6BF" },
                  }}
                />
              </div>
            </label>
            {uploadLoading.protection && <span style={{fontSize: '12px'}}>Uploading File... <CircularProgress size="30px" /></span>}
            {errors.protection && <p className="error">{errors.protection}</p>}
            {tender && tender.protection && (
              <Button
                sx={{
                  margin: "-6% 0 0 0 !important",
                  width: "max-content !important",
                  fontSize: "12px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.protection, user)}
              >
                {tender.protectionFilename || fileNames.protection}
              </Button>
            )}
          </Grid2>
        </Grid2>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button className="btn-contained" onClick={handleNext}>
          Next
        </Button>
      </Box>
    </div>
  );
};

export default EditStep6;
